import { render, staticRenderFns } from "./TradeOrderNewRevisionPart.vue?vue&type=template&id=2eb66ad9&scoped=true&"
import script from "./TradeOrderNewRevisionPart.vue?vue&type=script&lang=js&"
export * from "./TradeOrderNewRevisionPart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb66ad9",
  null
  
)

export default component.exports